'use strict';

angular.module('atex.art.content', []).factory('ArtContentStore',
['$q', '$rootScope', 'ApplicationConfigurationService', 'ArtGenericStore', 'ContentService', 'ArtTemplateStore', 'ArtInboxOptions',

  function($q, $rootScope, ApplicationConfigurationService, ArtGenericStore, ContentService, ArtTemplateStore, ArtInboxOptions) {
    var isOnlineFunc = function() {
      return true;
    };

    var simpleUID = function() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    };

    var dateObject = function(date) {
      if (_.isString(date)) {
        return new Date(Date.parse(date));
      }

      return date;
    };

    var isActId = function(id) {
      return typeof id === 'string' && id.indexOf('act:') === 0;
    };

    var mapContentRead = function(value) {
      if (value === null) {
          return null;
      }

      var content = atex.Content(value.data, value.meta, value.local);

      /**
       * When running on browsers where the polyfill is used, we have to
       * manually make sure that properties on our atex.Content objects
       * that should be Date objects are instantiated.
       */
      content.meta.creationDate = dateObject(content.meta.creationDate);
      content.meta.modificationDate = dateObject(content.meta.modificationDate);

      return content;
    };

    var constructArticle = function(responseInfo) {
      var article = atex.Content();

      article.meta.id = responseInfo.id;
      article.meta.creationDate = new Date(Number(responseInfo.meta.originalCreationTime));
      article.meta.modificationDate = new Date(Number(responseInfo.meta.modificationTime));
      article.meta.revision = responseInfo.revision;

      article.data = _.extend({}, responseInfo.data);

      article.local.persisted = true;
      article.local.existsOnServer = true;
      article.local.valid = true;

      return $q.when(article);
    };

    var filterAspects = function(article) {
      return ApplicationConfigurationService.getConfigurationFor(['filterAspects'],
          ["atex.ChannelContentData", "engagementAspect"]).then(function(filterAspects) {
        atex.act.AspectUtils.removeAspects(filterAspects, article);
      });
    };

    var cleanAndFilterArticle = function(article) {
      var json = angular.toJson(article);
      var cleanArticle = angular.fromJson(json);
      return filterAspects(cleanArticle).then(function() {
        return cleanArticle;
      });
    };

    var serverAdapter = {
      getById: function(id) {
        var transferInfo = { id: id};
        return ContentService.getContent(transferInfo).then(function(responseInfo) {
          return constructArticle(responseInfo);
        });
      },

      put: function (article) {
        return cleanAndFilterArticle(article).then(function(cleanArticle) {
          var dataToSend =  _.extend({ }, cleanArticle.data);

          var transferInfo = { id: cleanArticle.meta.id, data: dataToSend, revision: cleanArticle.meta.revision || cleanArticle.meta.etag };

          var dataApiFn = _.isEqual(cleanArticle.local.existsOnServer, false) ? ContentService.createContent : ContentService.updateContent;

          return dataApiFn(transferInfo).then(function(responseInfo) {
            var transferInfo = { id: responseInfo.id };

            return ContentService.getContent(transferInfo);
          }).then(function(responseInfo) {
            return constructArticle(responseInfo);
          });
        });
      }
    };

    var recursiveDelete = function(objectStoreName, id) {
      return contentStoreAdapter.getById('content', id).then(function(content) {
        return ArtTemplateStore.getTemplateFor(content).then(function(template) {
          var additionalPromises = [];

          if (template !== undefined) {
            var fields = template.dataBindings;

            if (fields !== undefined) {
              for (var j = 0; j < fields.length; j++) {
                var field = fields[j];

                if (field.widget === 'pResourceArea') {
                  var shortPath = field.path || field.domainObjects.data;
                  var path = atex.onecms.ObjectUtils.expandShortPath(shortPath);

                  var fieldData = atex.onecms.ObjectUtils.getByPath(content.data.aspects, path);

                  if (fieldData !== undefined) {
                    for (var i = 0; i < fieldData.length; i++) {
                      var resource = fieldData[i];

                      if (isActId(resource)) {
                        (function (resource) {
                          additionalPromises.push(recursiveDelete(objectStoreName, resource));
                        })(resource);
                      }
                    }
                  }
                }
              }
            } else {
              console.log("recursiveDelete: dataBindings is undefined");
            }
          } else {
            console.log("recursiveDelete: template is undefined");
          }

          return $q.all(additionalPromises);
        }).then(function() {
          return ArtGenericStore.deleteById(objectStoreName, id);
        });
      });
    };

    var contentStoreAdapter = {
      getById: function(objectStoreName, id) {
        return ArtGenericStore.getById(objectStoreName, id).then(function(result) {
          return mapContentRead(result);
        });
      },

      getAll: function(objectStoreName) {
        return ArtGenericStore.getAll(objectStoreName).then(function(results) {
          return results.map(mapContentRead);
        });
      },

      put: function(objectStoreName, article) {
        if (!article.meta.id) {
          /**
           * In the case where an article does not have an ID yet (which
           * in most cases means it's a new article), we generate a simple
           * string that looks like an UID.
           */

          article.meta.id = simpleUID();
        }

        var freshArticle = atex.Content(article.data, article.meta, article.local);

        var json = angular.toJson(freshArticle);
        var cleanArticle = angular.fromJson(json);

        return ArtGenericStore.put(objectStoreName, cleanArticle);
      },

      remove: function(objectStoreName, id) {
        return recursiveDelete(objectStoreName, id);
      },

      singleRemove: function(objectStoreName, id) {
        return ArtGenericStore.deleteById(objectStoreName, id);
      },

      putAll: function(objectStoreName, articles) {
        var promises = [];

        articles.forEach(function(article) {
          promises.push(ArtGenericStore.put(objectStoreName, article));
        });

        return $q.all(promises);
      },

      hasLocallyStored: function(objectStoreName, id) {
        return ArtGenericStore.getById(objectStoreName, id).then(function(result) {
          return result !== null;
        });
      }
    };

    var oneCMSContentList = [];
    var _syncSkipList = [];

    var synchronizer = {
      /**
       * Determines whether or not localContent should be synchronized.
       *
       * @param localContent atex.Content
       * @returns boolean, true or false
       */
      shouldSync: function(localContent) {
        // contents can be skippable, this is also checked when sync wants to save the content
        return localContent.local.existsOnServer && !_.contains(_syncSkipList, localContent.meta.id);
      },

      /**
       * Callback for when a content is synchronized, regardless of fail or success.
       *
       * @param id String
       * @param doRemove boolean
       */
      onPostSync: function(id, doRemove) {
        $rootScope.$broadcast('atex:contentSynchronized', id, doRemove);
      },

      /**
       * Callback for when a content fails to synchronize, sets error state on the article before it is
       * written to storage.
       *
       * @param localContent atex.Content
       * @param error atex.onecms.error.Error
       * @returns Object the content that should be stored locally, or undefined
       */
      onSyncByIdError: function(localContent, error) {
        // If the synchronization has failed prior to this,
        // let the error object know about that
        if (localContent.local.syncFailed) {
          error.hasFailedBefore = true;
        }

        // the content has been added to syncSkipList after call to shouldSync
        if (_.contains(_syncSkipList, localContent.meta.id)) {
          return undefined;
        }

        localContent.local.syncFailed = true;

        return localContent;
      },

      syncNewIds: function() {
        return oneCMSContentList;
      },

      readConfig: function() {
        if(synchronizer.articleLimit) {
          return $q.when();
        }

        var defaultLimit = 20;
        return ApplicationConfigurationService.getConfigurationFor(['browserStorage', 'maximumNumberOfArticles'], defaultLimit).then(function(articleLimit) {
          synchronizer.articleLimit = (!_.isNumber(articleLimit)) ? defaultLimit : articleLimit;
        });
      },

      /**
       * Callback for when a content is successfully synchronized. Decides which content (local, remote)
       * will be written to storage.
       *
       * @param localContent atex.Content
       * @param remoteContent atex.Content
       * @returns Object the content that should be stored locally, or undefined
       */
      onSyncByIdSuccess: function (localContent, remoteContent) {
        // the content has been added to syncSkipList after call to shouldSync
        if (_.contains(_syncSkipList, localContent.meta.id)) {
          return $q.when(undefined);
        }

        if (remoteContent && !localContent.local.persisted) {
          return ApplicationConfigurationService.getConfigurationFor(['serverDataSynchronization', 'detectChanges'], true).then(function(detectChanges) {
            if (detectChanges && (localContent.meta.revision !== remoteContent.meta.revision)) {
              localContent.local.conflict = remoteContent.meta;
            }
            localContent.local.syncFailed = undefined;

            return localContent;
          });
        }
        return $q.when(remoteContent);
      }
    };

      var mergeMaps = function (map1, map2) {
          for (var key in map2) {
              map1[key] = map2[key];
          }
          return map1;
      };

      var hasContentData = function(content) {
          return content.data !== undefined && content.data.aspects !== undefined &&
            content.data.aspects.contentData !== undefined && content.data.aspects.contentData.data !== undefined;
      };

      var updateFields = function (content,oldIdToNewIdMap) {
          if (!hasContentData(content)) {
              return content;
          }
          var contentDataFields = content.data.aspects.contentData.data;
          for (var key in contentDataFields) {
              if (!contentDataFields.hasOwnProperty(key)) {
                  continue;
              }

              var fieldData = contentDataFields[key];
              if (fieldData === undefined) {
                  continue;
              }
              if ( typeof fieldData === 'string') {
                  if (isActId(fieldData) && oldIdToNewIdMap[fieldData] !== undefined) {
                      contentDataFields[key] = oldIdToNewIdMap[fieldData];
                  }
                  continue;
              }

              for (var i = 0; i < fieldData.length; i++) {
                  if (isActId(fieldData[i]) && oldIdToNewIdMap[fieldData[i]] !== undefined) {
                      fieldData[i] = oldIdToNewIdMap[fieldData[i]];
                  }
              }
          }
          return content;
      };

    var recursiveSave = function(content, previouslyWalkedContent) {

      if (content === undefined || content === null) {
        return;
      }

      var oldId = content.meta.id;
      var existsOnServer = content.local.existsOnServer;
      var dataSnapshot = JSON.stringify(content.data);

        var oldIdToNewIdMap = [];
        var walkedContent = previouslyWalkedContent || [];
        walkedContent[content.meta.id] = true;

      if (existsOnServer) {
        delegatingStore.addToSyncSkipList(oldId);
      }

      return ArtTemplateStore.getTemplateFor(content).then(function(template) {
        var promises = [];

        if (template !== null && template !== undefined) {
            var fields = template.dataBindings;

            if (fields !== undefined) {
                for (var j = 0; j < fields.length; j++) {
                    var field = fields[j];

                    if (field.widget === 'pResourceArea') {
                        var shortPath = field.path || field.domainObjects.data;
                        var path = atex.onecms.ObjectUtils.expandShortPath(shortPath);

                        var fieldData = atex.onecms.ObjectUtils.getByPath(content.data.aspects, path);

                        if (fieldData !== undefined) {
                            for (var i = 0; i < fieldData.length; i++) {

                                var resource = fieldData[i];
                                var contentId;
                                if (isContentId(resource)) {
                                  contentId = convertContentIdToOneCmsId(resource);
                                } else {
                                  contentId = resource;
                                }
                                if (walkedContent[contentId] === true) {
                                    continue;
                                }
                                promises.push((function (contentId, i, currentField) {
                                    return contentStoreAdapter.getById('content', contentId)
                                    .then(function (resource) {
                                        return recursiveSave(resource, walkedContent);
                                    }).then(function (map) {
                                        oldIdToNewIdMap = mergeMaps(oldIdToNewIdMap, map);
                                        if (isActId(contentId)) {
                                          currentField[i] = oldIdToNewIdMap[contentId];
                                        }
                                    });
                                })(resource, i, fieldData));
                            }
                        }
                    }
                }
            } else {
                console.log("recursiveSave: dataBindings is undefined");
            }
        } else {
            console.log("recursiveSave: template is undefined");
        }
        return $q.allSettled(promises);
      }).then(function(results) {
        var errors = atex.onecms.AngularUtils.splitSettled(results).rejected;
        content = updateFields(content,oldIdToNewIdMap);

        if (errors.length > 0) {
          return contentStoreAdapter.put('content', content).then(function() {
            delegatingStore.removeFromSyncSkipList(content.meta.id);
          }).then(function() {
            return $q.reject(errors[0]);
          });
        }

        return serverAdapter.put(content).then(function(storedContent) {
          content.data = storedContent.data;
          content.meta = storedContent.meta;
          content.local = storedContent.local;

          oldIdToNewIdMap[oldId] = 'contentid/' + storedContent.meta.id;

          /**
           * if the article hasn't been to the server before the id is generated by us,
           * so we need to replace it.
           */
          if (!existsOnServer) {
            return contentStoreAdapter.singleRemove('content', oldId).then(function() {
              return contentStoreAdapter.put('content', storedContent);
            }).then(function() {
            return oldIdToNewIdMap;
            });
          }

          return contentStoreAdapter.put('content', storedContent).then(function() {
            delegatingStore.removeFromSyncSkipList(content.meta.id);
          return oldIdToNewIdMap;
          });
        }).then(undefined, function(error) {
          if (error.type === atex.onecms.error.types.CONFLICT) {
            /**
             * fallback to the previously stored snapshot in case of an error
             */
            content.data = JSON.parse(dataSnapshot);
            content.local.persisted = false;

            return serverAdapter.getById(content.meta.id).then(function(serverArticle) {
              content.local.conflict = serverArticle.meta;
              content.local.syncFailed = undefined;

              return contentStoreAdapter.put('content', content).then(function() {
                delegatingStore.removeFromSyncSkipList(content.meta.id);
                return $q.reject(error);
              });
            }).then(null, function(err) {
              delegatingStore.removeFromSyncSkipList(content.meta.id);

              if (error.type === atex.onecms.error.types.CONFLICT) {
                return $q.reject(error);
              }

              return $q.reject(atex.onecms.error.Error({
                severity: atex.onecms.error.severities.CRITICAL,
                cause: 'An error occurred when it was not supposed to.',
                rootCause: err,
                originalError: error
              }));
            });
          } else {
            return contentStoreAdapter.put('content', content).then(function() {
              delegatingStore.removeFromSyncSkipList(content.meta.id);
            }).then(function() {
              return $q.reject(error);
            });
          }
        });
      });
    };

    var isContentId = function(potentialContentId) {
      return typeof potentialContentId === 'string' && potentialContentId.indexOf('contentid/') === 0;
    };

    var convertContentIdToOneCmsId = function(contentId) {
      return contentId.substring(contentId.indexOf('/') + 1);
    };

    var recursiveModified = function(content, previouslyWalkedContent){
      if (content === undefined || content === null) {
        return;
      }
      var walkedContent = previouslyWalkedContent || [];
      var modified = !content.local.persisted || false;
      walkedContent[content.meta.id] = true;

      return ArtTemplateStore.getTemplateFor(content).then(function(template) {
        var promises = [];
        if(template !== undefined) {
          var fields = template.dataBindings;
          if (fields !== undefined) {
            for (var j = 0; j < fields.length; j++) {
              var field = fields[j];

              if (field.widget === 'pResourceArea') {

                var shortPath = field.path || field.domainObjects.data;
                var path = atex.onecms.ObjectUtils.expandShortPath(shortPath);

                var fieldData = atex.onecms.ObjectUtils.getByPath(content.data.aspects, path);

                if (fieldData !== undefined) {
                  for (var i = 0; i < fieldData.length; i++) {

                    var resource = fieldData[i];
                    if (walkedContent[content.meta.id] === true) {
                      continue;
                    }

                    promises.push((function (resource, i) {
                      return $q.when(isContentId(resource)).then(function (isContentId) {
                        if (isContentId) {
                          return contentStoreAdapter.getById('content', convertContentIdToOneCmsId(resource));
                        } else {
                          return contentStoreAdapter.getById('content', resource);
                        }
                      }).then(function (resource) {
                        return recursiveModified(resource, walkedContent);
                      }).then(function (resource) {
                        if (resource !== null && !resource.local.persisted) {
                          modified = true;
                        }
                      });
                    })(resource, i));
                  }
                }
              }
            }
          } else {
            console.log("recursiveModified: dataBindings are undefined");
          }
        } else {
          console.log("recursiveModified: template is undefined");
        }

        return $q.all(promises).then( function() {
          if (content.local.persisted && modified) {
            content.local.persisted = !modified;
            return contentStoreAdapter.put('content', content);
          }
          return;
        });
      }).then( function() {
        return content;
      });
    };

    var delegatingStore = atex.DelegatingStore(atex.onecms.AngularUtils.applyingQ($q, $rootScope),
        isOnlineFunc, serverAdapter, contentStoreAdapter, 'content', synchronizer, ArtInboxOptions);

    delegatingStore.setModifiedState = function(content) {
      return recursiveModified(content);
    };

    delegatingStore.sendToServer = function(content) {
      return recursiveSave(content);
    };

    delegatingStore.setConflictState = function(localArticle, serverArticle) {
      return constructArticle(serverArticle).then(function(article) {
        localArticle.local.conflict = article.meta;
        localArticle.local.syncFailed = undefined;
      });
    };

    delegatingStore.hasLocallyStored = function(id) {
      return contentStoreAdapter.hasLocallyStored('content', id);
    };

    delegatingStore.setOneCMSContentList = function(newOneCMSContentList) {
      oneCMSContentList = newOneCMSContentList;
    };

    delegatingStore.addToSyncSkipList = function(id) {
      if (!_.contains(_syncSkipList, id)) {
        _syncSkipList.push(id);
      }
    };

    delegatingStore.removeFromSyncSkipList = function(id) {
      _syncSkipList = _.without(_syncSkipList, id);
    };

    return delegatingStore;
  }
]);
